module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/core-js/promise.js
// module id = 57
// module chunks = 0